<script setup lang="ts">
import { ref } from "vue";
import Departments from "@/domains/home/services/configurations/views/settings/departments/Departments.vue";
import Occupation from "@/domains/home/services/configurations/views/settings/ocupations/Occupation.vue";
import UserManuals from "@/domains/home/services/configurations/views/settings/manuals/UserManuals.vue";
import Messenger from "@/domains/home/services/configurations/views/settings/messenger/Messenger.vue";
import Countries from "@/domains/home/services/configurations/views/settings/countries/Countries.vue";

const currentRoute = ref<string>('departments')

const select = (route: string) => {
  currentRoute.value = route
}
</script>

<template>
  <div class="flex flex-col">
    <div class="grid grid-cols-12 gap-4">
      <div class="flex flex-col col-span-2" style="cursor: pointer;">
        <div
            :class="[(currentRoute === 'departments') ? 'menu-pill-active' : 'menu-pill']"
            @click="select('departments')">
          <div class="flex">
            <div>Departments</div>
          </div>
        </div>
        <div
            :class="[(currentRoute === 'occupations') ? 'menu-pill-active' : 'menu-pill']"
            @click="select('occupations')"
        >
          <div class="flex">
            <div>Occupations</div>
          </div>
        </div>
        <div
            :class="[(currentRoute === 'countries') ? 'menu-pill-active' : 'menu-pill']"
            @click="select('countries')"
        >
          <div class="flex">
            <div>Countries</div>
          </div>
        </div>
        <div
            :class="[(currentRoute === 'manuals') ? 'menu-pill-active' : 'menu-pill']"
            @click="select('manuals')"
        >
          <div class="flex">
            <div>User Manuals</div>
          </div>
        </div>
        <div
            :class="[(currentRoute === 'messenger') ? 'menu-pill-active' : 'menu-pill']"
            @click="select('messenger')"
        >
          <div class="flex">
            <div>System Messenger</div>
          </div>
        </div>
      </div>
      <div class="col-span-10">
        <Departments v-if="currentRoute === 'departments'"/>
        <Occupation v-if="currentRoute === 'occupations'"/>
        <UserManuals v-if="currentRoute === 'manuals'"/>
        <Messenger v-if="currentRoute === 'messenger'"/>
        <Countries v-if="currentRoute === 'countries'"/>
      </div>
    </div>
  </div>
</template>
